import React, { useState, useRef } from 'react';
import { faInfo, faUserPlus, faUserCheck, faUserMinus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../../assignments.scss';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Tooltip } from 'react-bootstrap';
import moment from 'moment';
import AssignmentSettings from '../../../../../components/AssignmentSettings';
import { useAssignmentContext } from '../../../context';
import {
  useAssignToSelfMutation,
  useUnAssignFromMeMutation,
  useReAssignToSelfMutation,
  useIsSelfAssignedMutation,
  useChangeModeMutation,
  useLazyGetAssignmentSettingsDetailsQuery
} from '../../../../../features/authentication/assignmentApislice';
import Modal from '../../../../../components/Modal';
import CustomToast from '../../../../../components/Toast';
import PropTypes from 'prop-types';
import { capitalizeFirstLetter } from '../../../utils';

const ConfirmModal = ({
  isOpen,
  onClose,
  titleName,
  contentWidth,
  onConfirmCallback,
  disableButton,
  messageContent
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      titleName={titleName}
      contentWidth={contentWidth}
      detailHeight={'auto'}>
      <div className="modal-details">
        <div>
          <p className="mb-0">
            {' '}
            <div dangerouslySetInnerHTML={{ __html: messageContent }}></div>
          </p>
        </div>
      </div>
      <div className="d-flex justify-content-center gap-2">
        <button className="btn btn-castleRed confirm-btn" onClick={onClose}>
          No
        </button>
        <button
          disabled={disableButton}
          className="btn btn-castleWhite confirm-btn"
          onClick={() => onConfirmCallback()}>
          Yes
        </button>
      </div>
    </Modal>
  );
};

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  titleName: PropTypes.string,
  contentWidth: PropTypes.string,
  onConfirmCallback: PropTypes.func,
  messageContent: PropTypes.string,
  disableButton: PropTypes.bool
};
const SelfAssign = () => {
  const {
    assignmentId,
    useProtractor,
    calculatorEnabled,
    startDate,
    endDate,
    timeOnTaskEnabled,
    allowLangChange,
    showGrade,
    assignmentMode,
    availabilityOption,
    timeOnTaskSeconds,
    retakeLimitValue,
    retakeMode,
    retakeAvailabilty,
    retakeStartDate,
    retakeQuestion,
    includeCR,
    studentFileUpload,
    lockBrowser,
    photoMathBlock,
    autoStartCRUponGrading,
    autoLockQuestions,
    retakeEndDate,
    timedHour,
    timedMinute,
    isTimed,
    scoreRetries,
    retakesEnabled,
    setAssignmentMode,
    setAvailabilityOption,
    setAutoLockQuestions,
    setAllowAnswerChange,
    setShowGrade,
    setRetakesEnabled,
    setMasteryValue,
    setRetakeLimitValue,
    setIncludeCR,
    setUseProtractor,
    setCalculatorEnabled,
    setCalculatorType,
    setTextToSpeech,
    setStudentFileUpload,
    setAllowLangChange,
    setCrAnswerToolType,
    setIsTimed,
    setRandomized,
    setTimeOnTaskEnabled,
    setTimeOnTaskSeconds,
    setLockBrowser,
    setPhotoMathBlock,
    setAutoStartCRUponGrading,
    useRuler,
    setUseRuler,
    setTimedHour,
    setTimedMinute,
    crAnswerToolType,
    calculatorType,
    setInitialFromValue,
    setInitialToValue,
    initialToValue,
    initialFromValue,
    allowAnswerChange
  } = useAssignmentContext();
  const selectedAssignment = useAssignmentContext();
  const [assignToMyself, setAssignToMyself] = React.useState(false);
  const [unAssignFromMe] = useUnAssignFromMeMutation();
  const [reAssignToSelf] = useReAssignToSelfMutation();
  const [isSelfAssigned] = useIsSelfAssignedMutation();
  const [reassignToMyself, setReassignToMyself] = useState(false);
  const [assignToSelf] = useAssignToSelfMutation();
  const [changeMode] = useChangeModeMutation();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [getAssignmentSettingsDetails, assignmentSettingsResult] =
    useLazyGetAssignmentSettingsDetailsQuery();
  const [confirmModalTitle, setConfirmModalTitle] = useState('');
  const [confirmModalMessage, setConfirmModalMessage] = useState('');
  const confirmModalCallbackRef = useRef();

  React.useEffect(() => {
    if (assignmentId) {
      selfAsssignHandler();
      fetchAssignmentSettingsDetails();
    }
  }, []);

  const selfAsssignHandler = async () => {
    isSelfAssigned({ assignmentId: assignmentId })
      .unwrap()
      .then((res) => {
        setAssignToMyself(res);
        setReassignToMyself(res);
      });
  };

  const fetchAssignmentSettingsDetails = async () => {
    try {
      const res = await getAssignmentSettingsDetails(assignmentId).unwrap();
      setAssignmentMode(() => {
        return res.assignmentMode === 'Quiz with score' ? 'quiz' : res.assignmentMode.toLowerCase();
      });
      setAvailabilityOption(res.availability);
      setAutoLockQuestions(res.autoLockQuestions);
      setAllowAnswerChange(res.allowAnswerChange);
      setShowGrade(res.showGrade);
      setRetakesEnabled(res.assignRetake);
      setMasteryValue(res.masteryLevel);
      setRetakeLimitValue(res.retakeLimit);
      setIncludeCR(res.includeCR);
      setUseProtractor(res.useProtractor);
      setCalculatorEnabled(res.useCalc);
      setCalculatorType(res.calculatorType);
      setTextToSpeech(res.textToSpeech);
      setStudentFileUpload(res.studentFileUpload);
      setAllowLangChange(res.allowLanguageChange);
      setCrAnswerToolType(res.crAnswerToolId);
      setIsTimed(res.timed);
      setTimeOnTaskEnabled(res.timeOnTask);
      setTimeOnTaskSeconds(res.period);
      setLockBrowser(res.lockBrowser);
      setPhotoMathBlock(res.photoMathBlock);
      setAutoStartCRUponGrading(res.autoStartCRUponGrading);
      setUseRuler(res.ruler);

      var fromDateTime = new Date();
      fromDateTime.setHours(1);
      fromDateTime.setMinutes(0);
      var toDateTime = new Date();
      toDateTime.setHours(23);
      toDateTime.setMinutes(59);
      setInitialFromValue(fromDateTime);
      setInitialToValue(toDateTime);

      const hours = Math.floor(res.timeSpan / 60); // Calculate the number of hours
      const minutes = res.timeSpan % 60; // Calculate the remaining minutes

      setTimedHour(hours);
      setTimedMinute(minutes);
    } catch (err) {
      //Testing
    }
  };

  const resetAssignmentSettings = () => {
    if (!assignmentSettingsResult.isSuccess) return;

    var assignmentMode = assignmentSettingsResult.data.assignmentMode.toLowerCase().includes('quiz')
      ? 'quiz'
      : 'open';
    selectedAssignment.setAssignmentMode(assignmentMode);
    selectedAssignment.setAvailabilityOption(assignmentSettingsResult.data.availability);
    selectedAssignment.setAutoLockQuestions(assignmentSettingsResult.data.autoLockQuestions);
    selectedAssignment.setAllowAnswerChange(assignmentSettingsResult.data.allowAnswerChange);
    selectedAssignment.setAllowLangChange(assignmentSettingsResult.data.allowLanguageChange);
    selectedAssignment.setShowGrade(assignmentSettingsResult.data.showGrade);
    selectedAssignment.setRetakesEnabled(assignmentSettingsResult.data.assignRetake);
    selectedAssignment.setMasteryValue(assignmentSettingsResult.data.masteryLevel);
    selectedAssignment.setRetakeLimitValue(assignmentSettingsResult.data.retakeLimit);
    selectedAssignment.setIncludeCR(assignmentSettingsResult.data.includeCR);
    selectedAssignment.setUseProtractor(assignmentSettingsResult.data.useProtractor);
    selectedAssignment.setUseRuler(assignmentSettingsResult.data.useRuler == 1 ? true : false);
    selectedAssignment.setCalculatorEnabled(assignmentSettingsResult.data.useCalc);
    selectedAssignment.setCalculatorType(assignmentSettingsResult.data.calculatorType);
    selectedAssignment.setTextToSpeech(assignmentSettingsResult.data.textToSpeech);
    selectedAssignment.setStudentFileUpload(assignmentSettingsResult.data.studentFileUpload);
    selectedAssignment.setCrAnswerToolType(assignmentSettingsResult.data.crAnswerToolId);
    selectedAssignment.setIsTimed(assignmentSettingsResult.data.timed);
    selectedAssignment.setTimeOnTaskEnabled(assignmentSettingsResult.data.timeOnTask);
    selectedAssignment.setTimeOnTaskSeconds(assignmentSettingsResult.data.period);
    selectedAssignment.setLockBrowser(assignmentSettingsResult.data.lockBrowser);
    selectedAssignment.setPhotoMathBlock(assignmentSettingsResult.data.photoMathBlock);
    selectedAssignment.setAutoStartCRUponGrading(
      assignmentSettingsResult.data.autoStartCRUponGrading
    );
    selectedAssignment.setStartDate(assignmentSettingsResult.data.startDate);
    selectedAssignment.setEndDate(assignmentSettingsResult.data.endDate);
    selectedAssignment.setTimedHour(Math.floor(assignmentSettingsResult.data.timeSpan / 60));
    selectedAssignment.setTimedMinute(assignmentSettingsResult.data.timeSpan % 60);
  };

  const changeModeHandler = async () => {
    if (timedHour === 0 && timedMinute === 0 && isTimed) {
      CustomToast('Please enter a valid time span', 'error');
      return;
    }
    if (startDate === undefined) {
      CustomToast('Please enter a valid From date', 'error');
      setShowConfirmModal(false);
      setDisableButton(false);
      return;
    }
    if (endDate === undefined) {
      CustomToast('Please enter a valid To date', 'error');
      setShowConfirmModal(false);
      setDisableButton(false);
      return;
    }
    setDisableButton(true);

    const timeSpan =
      parseInt(selectedAssignment.timedHour) * 60 + parseInt(selectedAssignment.timedMinute);
    const value = {
      students: [{ studentId: -1, classId: 1 }],
      selfAssign: true,
      startDate: moment(startDate).format('YYYY-MM-DD HH:mm:ss'),
      endDate: moment(endDate).format('YYYY-MM-DD HH:mm:ss'),
      activity: 1,
      displayDeleted: false,
      allowAnswerChange: allowAnswerChange,
      showGrade: showGrade,
      assignmentMode: assignmentMode,
      availability: availabilityOption,
      timed: isTimed,
      timeSpan: timeSpan,
      autoLockQuestions: selectedAssignment.autoLockQuestions,
      allowLanguageChange: selectedAssignment.allowLangChange,
      useCalc: selectedAssignment.calculatorEnabled ? 1 : 0,
      useProtractor: selectedAssignment.useProtractor ? 1 : 0,
      useRuler: selectedAssignment.useRuler ? 1 : 0,
      timeOnTask: selectedAssignment.timeOnTaskEnabled,
      period: selectedAssignment.timeOnTaskSeconds,
      practice: false,
      assignRetake: selectedAssignment.retakesEnabled,
      masteryLevel: selectedAssignment.masteryValue,
      retakeLimit: selectedAssignment.retakeLimitValue,
      retakeMode: selectedAssignment.retakeMode,
      retakeQuestions: selectedAssignment.retakeQuestion,
      includeCR: selectedAssignment.includeCR,
      retakeAvailability: selectedAssignment.retakeAvailabilty,
      retakeStartDate: selectedAssignment.startDate,
      retakeEndDate: selectedAssignment.endDate,
      retakeTimed: selectedAssignment.isTimed,
      retakeTimeSpan: timeSpan,
      showIdentificationFields: false,
      retakeRetries: selectedAssignment.scoreRetries,
      studentPrinting: false,
      StudentFileUpload: studentFileUpload,
      lockBrowser: lockBrowser,
      photoMathBlock: photoMathBlock,
      autoStartCRUponGrading: autoStartCRUponGrading,
      ruler: useRuler ? 1 : 0,
      crAnswerToolId: crAnswerToolType,
      calculatorType: calculatorType
    };

    const options = {
      assignmentId: assignmentId,
      data: value
    };
    try {
      await changeMode(options).unwrap();
      await getAssignmentSettingsDetails(assignmentId).unwrap();
      CustomToast('Assignment mode changed successfully', 'success');
      setShowConfirmModal(false);
      setDisableButton(false);
    } catch (err) {
      CustomToast(err.data, 'error');
      setShowConfirmModal(false);
      setDisableButton(false);
    }
  };

  const handleAssignToSelf = async () => {
    const options = {
      assignmentId: assignmentId
    };
    try {
      await assignToSelf(options).unwrap();
      setAssignToMyself(!assignToMyself);
      setReassignToMyself(true);
      CustomToast('Assigned to you in Open mode', 'success');
      await getAssignmentSettingsDetails(assignmentId).unwrap();
    } catch (err) {
      if (err.originalStatus === 400) {
        CustomToast(`${err.data}`, 'error');
      }
    }
  };

  const handleUnassignToSelf = async () => {
    const options = {
      assignmentId: assignmentId
    };
    try {
      setDisableButton(true);
      await unAssignFromMe(options).unwrap();
      setDisableButton(false);
      setShowConfirmModal(false);
      setAssignToMyself(!assignToMyself);
      setReassignToMyself(false);
      CustomToast('Unassigned from you', 'success');
    } catch (err) {
      setDisableButton(false);
      setShowConfirmModal(false);
    }
  };

  const handleReAssignConfirm = () => {
    setConfirmModalMessage(
      'Are you sure that you want to reassign this assignment to yourself? By reassigning, answers in your session are cleared.'
    );
    setConfirmModalTitle('Reassign To Self');
    confirmModalCallbackRef.current = handleReAssignMyself;
    setShowConfirmModal(true);
  };

  const handleUnassignConfirm = () => {
    setConfirmModalMessage(
      'Are you sure that you want to unassign this assignment from yourself? You will be able to reassign it to yourself again.'
    );
    setConfirmModalTitle('Unassigned From Self');
    confirmModalCallbackRef.current = handleUnassignToSelf;
    setShowConfirmModal(true);
  };

  const handleChangeModeConfirm = () => {
    if (selectedAssignment.availabilityOption == 'FromTo') {
      const currentDate = moment().format('YYYY/MM/DD h:mm A'); // Get the current date/time
      if(moment(selectedAssignment.startDate).isBefore(currentDate, 'day')){
        CustomToast('From Date must not be before the current day', 'error');
        return;
      }
      if(moment(selectedAssignment.endDate).isBefore(currentDate)){
        CustomToast('To Date must not be before the current date/time', 'error');
        return;
      }
      if(moment(selectedAssignment.endDate).isBefore(moment(selectedAssignment.startDate)) || moment(selectedAssignment.endDate).isSame(moment(selectedAssignment.startDate))){
        CustomToast('To Date must be after the From Date', 'error');
        return;
      }
    }
    
    setConfirmModalMessage(`<center>Are you sure you want to change the Assignment mode to <br /> 
    <b>"${capitalizeFirstLetter(assignmentMode)} 
    ${isTimed ? 'Timed' : ''} 
    
    ${availabilityOption === 'FromTo'
    ? `${startDate !== undefined ? moment(startDate).format('DD/MM/y h:mm A') + ' - ' : ''}
      ${endDate !== undefined ? moment(endDate).format('DD/MM/y h:mm A') : ''}`
    : ''}
    "</b>
    <br /> for this assignment to you?</center>`);
    setConfirmModalTitle('Change Mode');
    confirmModalCallbackRef.current = changeModeHandler;
    setShowConfirmModal(true);
  };

  const handleReAssignMyself = () => {
    if (assignToMyself) {
      const options = {
        assignmentId: assignmentId
      };
      try {
        setDisableButton(true);
        reAssignToSelf(options).unwrap();
        setDisableButton(false);
        setShowConfirmModal(false);
        selectedAssignment.setAssignmentMode('open');
        CustomToast('Reassigned to you in Open mode', 'success');
      } catch (err) {
        setDisableButton(false);
        setShowConfirmModal(false);
      }
    }
  };

  return (
    <>
      <div className="white-card mb-4">
        <div className="col-12 info-text d-flex align-items-center">
          <span className="flex-shrink-0">
            <FontAwesomeIcon icon={faInfo} />
          </span>
          {!assignToMyself && (
            <p>
              Assign to self to view like a student or use for a class review with your projector
              and screen. Use the <strong>Student Center</strong> link found in your Teacher Center
              to see assignment. To assign to students, use Assign to Students or Quick Assign.
            </p>
          )}
          {assignToMyself && (
            <p>
              This assignment is currently assigned to you. You can access this assignment by
              selecting <strong>Student Center</strong>. If you have made changes to the assignment
              or if you wish to clear your answers, then you can reassign it to yourself.
            </p>
          )}
        </div>
        <div className="d-flex gap-3 mt-4 flex-wrap align-items-center">
          {!assignToMyself && (
            <div onClick={handleAssignToSelf} className="self-assign-card">
              <FontAwesomeIcon icon={faUserPlus} />
              Assign to myself
            </div>
          )}
          {assignToMyself && (
            <div onClick={handleUnassignConfirm} className="self-assign-card">
              <FontAwesomeIcon icon={faUserMinus} />
              Unassign from myself
            </div>
          )}
          <OverlayTrigger
            key="tooltip-reassign"
            placement="top"
            overlay={
              <Tooltip id="reassign-info" className="custom-tooltip">
                <p>
                  Reassign to myself in Open mode. After reassigning, use Change Mode if desired.
                </p>
              </Tooltip>
            }>
            <div
              onClick={handleReAssignConfirm}
              className={`self-assign-card ${
                !reassignToMyself && 'disabled disable-Pointer-Events'
              }`}>
              <FontAwesomeIcon icon={faUserCheck} />
              Reassign to myself
            </div>
          </OverlayTrigger>
        </div>
      </div>

      <div className="white-card self-assign-settings mb-4">
        {assignToMyself && !assignmentSettingsResult.isFetching && (
          <>
            <AssignmentSettings
              allowRetakesOption={false}
              twoColumn={true}
              reviewOnlyRadio={true}
              lockedRadio={true}
              randomizedQuestion={false}
              disabledTextSpeach={false}
              presetSettingsCallback={resetAssignmentSettings}
              allowOfflineMode={true}
              isSelfAssign={true}
            />
            <div className="d-flex justify-content-end gap-3">
              <button onClick={() => resetAssignmentSettings()} className="btn btn-width btn-castleWhite">
                Cancel
              </button>
              <button onClick={handleChangeModeConfirm} className="btn btn-castleRed">
                Change Mode
              </button>
            </div>
          </>
        )}
      </div>
      {assignToMyself && (
        <div className="col-12 info-text d-flex align-items-start">
          <span className="flex-shrink-0">
            <FontAwesomeIcon icon={faInfo} />
          </span>
          <p>
            <strong>Note:</strong> The Assignment Mode for the self-assigned assignment is separate
            from the Assignment Mode for your students. Setting the Assignment Mode on this page
            only affects the assignment made to you, which you can access by clicking the Student
            Center link on the Teacher Center. Use the other tabs - Assignment To Students, Quick
            Assign, and Assignment Results (for modifying the mode) - to set/modify the Assignment
            Mode for your students.
          </p>
        </div>
      )}

      <ConfirmModal
        isOpen={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onConfirmCallback={confirmModalCallbackRef.current}
        contentWidth={'50%'}
        titleName={confirmModalTitle}
        setDisableButton={setDisableButton}
        disableButton={disableButton}
        messageContent={confirmModalMessage}
      />
    </>
  );
};

SelfAssign.propTypes = {
  assignmentId: PropTypes.number.isRequired,
  assignToMyself: PropTypes.bool.isRequired,
  setAssignToMyself: PropTypes.func.isRequired,
  reassignToMyself: PropTypes.bool.isRequired,
  setReassignToMyself: PropTypes.func.isRequired
};

export default SelfAssign;
